<template>
    <rkm-area
        title="Desfecho do atendimento"
        type="section"
    >
        <Form
            :data="data"
            :is-medico="isMedico"
            :is-saved="isSaved"
        />
    </rkm-area>
</template>

<script>
import Form from './Form'

export default {
    components: { Form },
    props: {
        data: { type: Object, required: true },
        isMedico: { type: Boolean, default: true },
        isSaved: { type: Boolean, default: false },
    },
}
</script>